import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { AuthService } from "./core/auth/auth.service";

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver  {
    /**
     * Constructor
     */
    constructor(
        private _navigationService: NavigationService,
        private _authService: AuthService,
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return this._navigationService.get();
    }
}
